import React from 'react';
import CloseButton from '../components/CloseButton';
 
export default function GrafanaPanel({ onClose = null }) {
  
  const GRAFANA_URL = "https://grafana.zenit.poznan.pl/grafana/public-dashboards/5b3fb823039f46aa8d7eb1026bbf8645";
    
  // Check if URL is valid
  const isValidUrl = (urlString) => {
    try {
      new URL(urlString);
      return true;
    } catch (e) {
      return false;
    }
  };

  const hasValidUrl = isValidUrl(GRAFANA_URL);

  return (
    <div style={{
      width: '95vw',
      height: '95vh',
      maxWidth: '1400px',
      maxHeight: '900px',
      background: '#fff',
      borderRadius: 16,
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Header with title and close button */}
      <div style={{
        background: '#333',
        color: '#fff',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '16px 16px 0 0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12
        }}>
          <span style={{ fontSize: '1.5rem' }}>📊</span>
          <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Grafana Dashboard</span>
        </div>
        <CloseButton 
          onClick={onClose}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)'
          }}
        />
      </div>

      {/* Iframe container */}
      <div style={{
        width: '100%',
        height: 'calc(100% - 60px)',
        background: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {hasValidUrl ? (
          <iframe
            src={GRAFANA_URL}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              background: '#fff'
            }}
            title="Grafana Dashboard"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#666'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '20px' }}>⚠️</div>
            <h3 style={{ margin: '0 0 16px 0', color: '#333' }}>Invalid Dashboard URL</h3>
            <p style={{ margin: '0', lineHeight: '1.5' }}>
              Please provide a valid Grafana dashboard URL.<br/>
              <code style={{ 
                background: '#eee', 
                padding: '2px 6px', 
                borderRadius: '4px',
                fontSize: '0.9rem'
              }}>
                {GRAFANA_URL}
              </code>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}